'use client';

import { useEffect, useState } from "react";
import Loader from "./components/Loader";
import BootstrapClient from "./bootstrap.client";

declare global {
  interface Window {
    voiceflow?: any;
    openVFChat?: () => void;
  }
}

export default function ClientLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const handleComplete = () => setLoading(false);

    if (document.readyState === "complete") {
      handleComplete();
    } else {
      window.addEventListener("load", handleComplete);
    }

    return () => window.removeEventListener("load", handleComplete);
  }, []);

  useEffect(() => {
    // Voiceflow
    const vfScript = document.createElement("script");
    vfScript.src = "https://cdn.voiceflow.com/widget/bundle.mjs";
    vfScript.async = true;

    vfScript.onload = () => {
      window.voiceflow?.chat?.load({
        verify: { projectID: "66ba85a2cf5adb4c27b4fc0e" },
        url: "https://general-runtime.voiceflow.com",
        versionID: "production",
      });

      window.openVFChat = () =>
        window.voiceflow?.chat?.open();
    };

    document.body.appendChild(vfScript);

    // Google Analytics
    const gaScript = document.createElement("script");
    gaScript.src = "https://www.googletagmanager.com/gtag/js?id=G-RJLHRFWD5T";
    gaScript.async = true;
    document.head.appendChild(gaScript);

    const inlineGAScript = document.createElement("script");
    inlineGAScript.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', 'G-RJLHRFWD5T');
    `;
    document.head.appendChild(inlineGAScript);
  }, []);

  return (
    <>
      {loading && <Loader loading />}
      {!loading && children}
      <BootstrapClient />
    </>
  );
}
